import { crudService } from '../../../services/api/crudService';
import type { Customer, CustomerInput } from '../types/customerTypes';

export const customerService = {
  ...crudService<Customer, CustomerInput>('/customers'),
  /** Account statement endpoint, used by <LedgerStatement path=… />. */
  ledgerPath: (id: string) => `/customers/${id}/ledger`,
};
